{
  "filterPOHProductsInSearch": true
}
